import { render, staticRenderFns } from "./OrgMonitor.vue?vue&type=template&id=5af0aad4"
import script from "./OrgMonitor.vue?vue&type=script&lang=js"
export * from "./OrgMonitor.vue?vue&type=script&lang=js"
import style0 from "./OrgMonitor.vue?vue&type=style&index=0&id=5af0aad4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports